document.addEventListener('DOMContentLoaded', function() {
    // Inject CSS for the fade/slide animation
    const style = document.createElement('style');
    style.textContent = `
        .leakproof-slider {
            opacity: 0;
            transform: translateX(100%);
            transition: opacity 0.5s ease, transform 0.5s ease;
        }
        .leakproof-slider.show {
            opacity: 1;
            transform: translateX(0);
        }
    `;
    document.head.appendChild(style);

    const leakproofLink = document.querySelector('.leakproof-link');
    const leakproofSlider = document.querySelector('.leakproof-slider');
    const leakproofClose = document.querySelector('.leakproof-close');
    if (!leakproofLink || !leakproofSlider) return;

    // Function to close the slider
    function closeSlider() {
        leakproofSlider.classList.remove('show');
        // Wait for animation to complete before hiding
        setTimeout(() => {
            leakproofSlider.style.display = 'none';
        }, 500); // Match transition duration
    }

    // Toggle slider on leakproof-link click
    leakproofLink.addEventListener('click', function(event) {
        event.preventDefault(); // Prevent default link behavior
        if (leakproofSlider.style.display === 'none' || !leakproofSlider.style.display) {
            leakproofSlider.style.display = 'block';
            // Trigger reflow to ensure animation plays
            leakproofSlider.offsetWidth;
            leakproofSlider.classList.add('show');
        } else {
            closeSlider();
        }
    });

    // Hide slider on leakproof-close click
    if (leakproofClose) {
        leakproofClose.addEventListener('click', function(event) {
            event.preventDefault(); // Prevent default link behavior
            closeSlider();
        });
    }

    // Close slider on outside click
    document.addEventListener('click', function(event) {
        const isClickInsideSlider = leakproofSlider.contains(event.target);
        const isClickOnLink = leakproofLink.contains(event.target);
        const isClickOnClose = leakproofClose && leakproofClose.contains(event.target);

        if (!isClickInsideSlider && !isClickOnLink && !isClickOnClose && leakproofSlider.classList.contains('show')) {
            closeSlider();
        }
    });

    const observer = new MutationObserver(function(mutations, obs) {
        const absorbencyLegend = document.querySelector('legend[data-name="Absorbency"]');
        if (absorbencyLegend) {
            absorbencyLegend.insertAdjacentElement('afterend', leakproofLink);
            leakproofLink.style.display = 'block';
            console.log("Absorbency exists, leakproof link moved");
            obs.disconnect(); // Stop observing once found
        }
    });

    observer.observe(document.body, { childList: true, subtree: true });

    // Initial check in case element is already present
    const absorbencyLegend = document.querySelector('legend[data-name="Absorbency"]');
    if (absorbencyLegend) {
        absorbencyLegend.insertAdjacentElement('afterend', leakproofLink);
        leakproofLink.style.display = 'block';
        console.log("Absorbency exists, leakproof link moved");
        observer.disconnect();
    } else {
        leakproofLink.style.display = 'none';
    }
});